import { downloadInitiativeIcs } from "./calendar";

const pad = (n) => String(n).padStart(2, "0");

export function downloadAppointmentIcs(appt, { t, lang }) {
  const start = new Date(appt.start_utc);
  const end = new Date(appt.end_utc || appt.start_utc);
  const ymdt = (d) => `${d.getUTCFullYear()}${pad(d.getUTCMonth() + 1)}${pad(d.getUTCDate())}T${pad(d.getUTCHours())}${pad(d.getUTCMinutes())}00Z`;
  const esc = (v) => (v || "").replace(/\\/g, "\\\\").replace(/;/g, "\\;").replace(/,/g, "\\,").replace(/\n/g, "\\n");
  const title = `${t("booking.cal_event_title")} ${appt.psychologist_name}`;
  const loc = appt.modality === "online" ? (appt.online_info || "Online") : (appt.location || "");
  const desc = [appt.type_label, appt.modality, `${window.location.origin}/profesionales/${appt.psychologist_id}`].filter(Boolean).join("\n");
  const now = new Date();
  const ics = [
    "BEGIN:VCALENDAR", "VERSION:2.0", "PRODID:-//ConQuienHoy//Appointments//EN", "CALSCALE:GREGORIAN", "BEGIN:VEVENT",
    `UID:conquienhoy-appt-${appt.id}@conquienhoy.com`, `DTSTAMP:${ymdt(now)}`,
    `DTSTART:${ymdt(start)}`, `DTEND:${ymdt(end)}`,
    `SUMMARY:${esc(title)}`, loc ? `LOCATION:${esc(loc)}` : "", `DESCRIPTION:${esc(desc)}`,
    "END:VEVENT", "END:VCALENDAR",
  ].filter(Boolean).join("\r\n");
  const blob = new Blob([ics], { type: "text/calendar;charset=utf-8" });
  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob);
  a.download = `cita_${appt.id}.ics`;
  document.body.appendChild(a); a.click(); a.remove();
  URL.revokeObjectURL(a.href);
}

export { downloadInitiativeIcs };
